import { useApiClient } from '@/composables/useApiClient'
import { CategoryOnboard } from '@/view-models/category'

export const state = () => ({
  indexRegionID: null,
  regionID: 1,
  regions: [],
  regionsMap: {},
  region: {},
  indexRegion: {},
  regionSearchMap: {},
  categories: [],
  themes: [],
  brands: [],
  tags: [],
  regionPopular: null,
  filters: {},
})

export const getters = {
  indexRegion: state => state.indexRegion,
  regionID: state => state.regionID,
  allRegions: state => state.regions,
  regionsMap: state => state.regionsMap,
  region: state => state.region,
  regionSearchMap: state => state.regionSearchMap,
  categories: state => state.categories,
  themes: state => state.themes,
  brands: state => state.brands,
  tags: state => state.tags,
  regionPopular: state => state.regionPopular,
  filters: state => state.filters,
}

export const actions = {
  async getAllRegion({ commit, dispatch, state }) {
    const res = await useApiClient().$get(`/pub/region`)
    if (res.code === 0) {
      commit('SET_ALLREGION', res.data)
      commit('SET_REGIONS_MAP', res.data)
      return res.data
    }
  },
  async getRegion({ commit, dispatch }, regionID) {
    try {
      const res = await dispatch('doRegionAPI', regionID)
      if (res.code === 0 && res.data) {
        const categories =
          res.data?.category?.filter(category => {
            // 外送酒ID prod: 10973, stg: 10797
            // const disabledCategory = isProduction ? 10973 : 10797
            const disabledCategory = 10973
            return category.onboard === 0 && disabledCategory !== category.id && category.web_onboard !== CategoryOnboard.Hidden
          }) || []
        const themes = res.data?.theme?.filter(theme => theme.web_onboard !== CategoryOnboard.Hidden) || []
        res.data.category = categories
        res.data.theme = themes
        commit('SET_REGION', res.data)
        commit('SET_CATEGORIES', categories)
        commit('SET_THEMES', res.data.theme)
        commit('SET_BRANDS', res.data.brand)
        commit('SET_TAGS', res.data.tag)
        commit('SET_INDEX_REGION', res.data)
        return res.data
      }

      return {}
    } catch (error) {
      console.error(`getRegion error: `, error)
    }
  },
  async getRegionPopular({ commit }, regionID) {
    commit('SET_REGION_POPULAR', [])
    const res = await useApiClient().$get(`/pub/region/${regionID}/popular`)
    if (res.code === 0 && res.data) {
      commit('SET_REGION_POPULAR', res.data)
      return res.data
    }
  },
  getSearchRegionContent({ dispatch, commit }, regionID) {
    return dispatch('doRegionAPI', regionID).then(res => {
      if (res.code === 0 && res.data) {
        commit('SET_REGION_SEARCH_MAP', { id: regionID, data: res.data })
        return res.data
      }
    })
  },
  doRegionAPI({ commit }, regionID) {
    return useApiClient().$get(`/pub/region/${regionID}`)
  },
  setRegionID({ commit }, regionID) {
    commit('SET_REGION_ID', regionID)
  },
  getRegionRecommendedProducts({ commit }, regionID) {
    return useApiClient().$get(`/region/${regionID}/recommended-products`)
  },
  setFilters({ commit }, filters) {
    commit('SET_FILTERS', filters)
  },
}

export const mutations = {
  SET_ALLREGION(state, payload) {
    state.regions = payload
  },
  SET_REGIONS_MAP(state, regions) {
    const regionsMap = {}
    regions.forEach(region => {
      regionsMap[region.region_id] = region
    })
    state.regionsMap = regionsMap
  },
  SET_REGION(state, region) {
    state.region = region
  },
  SET_INDEX_REGION(state, indexRegion) {
    state.indexRegion = indexRegion
  },
  SET_CATEGORIES(state, categories) {
    state.categories = Array.isArray(categories) ? categories : []
  },
  SET_THEMES(state, data) {
    if (data && data.length > 0) {
      state.themes = data
    }
  },
  SET_BRANDS(state, data) {
    state.brands = Array.isArray(data) ? data : []
  },
  SET_TAGS(state, data) {
    if (data && data.length > 0) {
      state.tags = data
    }
  },
  SET_REGION_POPULAR(state, payload) {
    state.regionPopular = payload
  },
  SET_REGION_ID(state, regionID) {
    state.regionID = regionID
  },
  SET_REGION_SEARCH_MAP(state, region) {
    const newMap = {}
    newMap[region.id] = region.data
    state.regionSearchMap = Object.assign({}, state.regionSearchMap, newMap)
  },
  SET_FILTERS(state, filters) {
    const filterMap = Object.assign({}, state.filters)
    for (const name in filters) {
      if (filters[name]) {
        filterMap[name] = filters[name]
      } else {
        delete filterMap[name]
      }
    }
    state.filters = Object.assign({}, { ...filterMap })
  },
}
